import React from 'react';
import { renderBarChart } from './BarChartFormatter';
import { renderLineChart } from './LineChartFormatter';
import { renderPieChart } from './PieChartFormatter';

export const GraphComponent = ({ graphData, theme, enableAnimation = true }) => {
  const { type, title } = graphData;

  // Determine which chart renderer to use based on type
  switch (type) {
    case 'bar':
    case 'column':
      return renderBarChart(graphData, theme, enableAnimation);
    
    case 'line':
      return renderLineChart(graphData, theme);
    
    case 'pie':
      return renderPieChart(graphData, theme);
    
    default:
      // Fallback for unsupported chart types
      return (
        <div 
          className="w-full p-4 rounded-lg text-center"
          style={{
            backgroundColor: theme.colors.cardBackground,
            border: `1px solid ${theme.colors.cardBorder}`,
          }}
        >
          {title && (
            <h3 
              className="text-lg font-semibold mb-4"
              style={{ color: theme.colors.text }}
            >
              {title}
            </h3>
          )}
          <div
            className="p-6"
            style={{ color: theme.colors.textSecondary }}
          >
            <p className="text-sm">
              Chart type "{type}" is not yet supported.
            </p>
            <p className="text-xs mt-2">
              Supported types: bar, column, line, pie
            </p>
          </div>
        </div>
      );
  }
};

// Keep the old function for backward compatibility
export const renderGraph = (graphData, theme, enableAnimation = true) => {
  return <GraphComponent graphData={graphData} theme={theme} enableAnimation={enableAnimation} />;
};

export default renderGraph; 